import {AbstractPart} from "./AbstractPart";
import {IFormPartParameters} from "./index";
import {nsForm} from "../../nsForm";
import str2Bool = nsForm.str2Bool;
import areaboxHtml from './areabox.html?raw';

export let template = areaboxHtml;

export class viewModel extends AbstractPart {
    private isRequired: boolean;
    private rows: string;

    constructor(params: IFormPartParameters) {
        super(params);
        switch (this.value()) {
            case undefined:
            case null:
                this.value(this.parameters[2] ?? '');
        }
        this.isRequired = str2Bool(this.parameters[3] ?? '');
        this.rows = this.parameters[4] ?? '';
        this.attr = {
            required: this.isRequired,
            rows: this.rows,
        };
    }

    override isValid(): boolean {
        const a = this.isRequired ? !!this.value() : true;
        this.et.update(!a, this.value, 'Mangler verdi');
        return a;
    }

}
